import axiosInstanceProxy, { axiosLoginProxy } from "./config";

export const loginRequest = (username, password) =>
  axiosLoginProxy.post("/admin/auth/login", { email: username, password });

export const logoutRequest = () => axiosInstanceProxy.post("/admin/auth/logout");

export const getProfileRequest = () => axiosInstanceProxy.post("/admin/auth/me");
